import { ReactNode } from "react";

interface MockupWindowProps {
	children: ReactNode;
	className?: string;
}

/**
 * Browser-window frame used as a screenshot stand-in for the NIS360 platform.
 * Replace the mockup contents with real product screenshots once available.
 */
export default function MockupWindow({ children, className = "" }: MockupWindowProps) {
	return (
		<div
			className={`w-full bg-white rounded-2xl shadow-[0_24px_64px_rgba(13,23,55,0.25)] overflow-hidden border border-[#E6E6EC] ${className}`}
		>
			<div className="flex items-center gap-2 px-4 py-3 bg-[#F7F8FB] border-b border-[#E6E6EC]">
				<span className="w-3 h-3 rounded-full bg-[#FC5753]" />
				<span className="w-3 h-3 rounded-full bg-[#FDBC40]" />
				<span className="w-3 h-3 rounded-full bg-[#33C748]" />
				<div className="ml-3 flex-1 max-w-[260px] h-6 bg-white border border-[#E6E6EC] rounded-md flex items-center px-3">
					<span className="text-[11px] text-[#626373] font-urbanist truncate">app.nis360.de</span>
				</div>
			</div>
			<div className="p-4 sm:p-5">{children}</div>
		</div>
	);
}
